module.exports = __webpack_public_path__ + "static/header-image-mobile@2x-d10bc48893f216a0714f243a2b7c5462.webp";